<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="left">
        <strong>© {{ year }} Jim Hardt Photography</strong>
      </div>
      <nav class="links">
        <router-link to="/impressum">Impressum</router-link>
        <router-link to="/datenschutz">Datenschutz</router-link>
        <router-link to="/kontakt">Kontakt</router-link>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>

<style scoped>
.footer { background:#0e0e0e; color:#bbb; padding:20px 0; margin-top:40px; }
.footer-inner { max-width:1100px; margin:0 auto; padding:0 16px; display:flex; justify-content:space-between; align-items:center; gap:16px; }
.links a { color:#bbb; margin-left:16px; text-decoration:none; }
.links a:hover { color:#fff; }
</style>
